<template>
  <div class="calendar-allday-menu">
    <div
      v-if="tasks.length > 0"
      class="calendar-allday-menu-left"
    >
      <div class="calendar-allday-menu-label">全天</div>
      <div
        v-if="maxTaskNumber > 2"
        class="calendar-allday-menu-toggle"
        @click="showAll"
      >
        <em v-if="showTaskNumber > 2" class="ibass ibass-arrow-up"></em>
        <em v-else class="ibass ibass-arrow-down"></em>
      </div>
    </div>
    <div
      v-if="tasks.length > 0"
      class="calendar-allday-menu-items"
      :style="{
        height: maxHeight
      }"
      :class="{
        'transition': showTaskNumber > 2
      }"
    >
      <div
        v-for="(item, index) in weekBlock"
        :key="index"
        class="calendar-allday-block"
        ref="calendarAllDayBlock"
        @dblclick="createTask(index)"
      >
        <div
          v-show="taskCounter[index] > showTaskNumber && showTaskNumber === 2"
          class="calendar-allday-block-wrap"
          @click="showAll"
        >
          <span class="calendar-allday-block-label">{{ `更多 ${taskCounter[index] - showTaskNumber} 个` }}</span>
          <em class="ibass ibass-trig-down"></em>
        </div>
      </div>
    </div>
    <div class="calendar-allday-tasks">
      <week-task
        :tasks="filteredTasks"
        :monday="monday"
        :size="weekTaskSize"
        :levelNum="showTaskNumber"
      />
    </div>
  </div>
</template>
<script>
import WeekTask from './weekTask'
const DEFAULT_SHOW_NUMBER = 2
export default {
  name: 'CalendarAllDayTask',
  components: {
    WeekTask
  },
  props: {
    tasks: {
      type: Array
    },
    monday: {
      type: Number
    },
    isMore: {
      type: Boolean
    }
  },
  data () {
    return {
      weekBlock: new Array(7),
      moday: '',
      taskCounter: {},
      showTaskNumber: DEFAULT_SHOW_NUMBER,
      maxTaskNumber: 0,
      pageX: -1,
      weekTaskSize: 0
    }
  },
  computed: {
    filteredTasks () {
      return this.tasks.slice(0)
    },
    maxHeight () {
      let allDayHeight = `${Math.min(this.maxTaskNumber, this.showTaskNumber === DEFAULT_SHOW_NUMBER
        ? this.showTaskNumber + 1
        : this.showTaskNumber) * 22 + 8}px`
      return allDayHeight
    }
  },
  watch: {
    tasks (newVal) {
      this.taskCounter = {}
      this.maxTaskNumber = 0
      this.setWeekBlock(newVal)
    },
    maxTaskNumber (after, before) {
      if (this.showTaskNumber === before) {
        this.showTaskNumber = after
      }
    },
    monday (after, before) {
      // 日期切换，全天任务收展复位
      this.showTaskNumber = DEFAULT_SHOW_NUMBER
    }
  },
  created () {
    this.setWeekBlock(this.tasks)
  },
  methods: {
    createTask (index) {
      let params = moment(this.monday).add(index, 'day').valueOf()
      this.$emit('createTask', params)
    },
    setWeekBlock (tasks) {
      tasks.map((task) => {
        this.setTaskNumByDay(this.monday, task)
      })

      this.$nextTick(() => {
        try {
          // 动态设置宽度，用于定位任务块位置
          this.weekTaskSize = this.$refs.calendarAllDayBlock[0].offsetWidth
        } catch (error) {}
      })
    },
    /**
     * 按天统计任务数,并将任务加入到每天
     */
    setTaskNumByDay (monday, item) {
      const param = Math.max(moment(item.startTime || item.dueTime).diff(moment(monday).startOf('day'), 'days'), 0)
      if (isNaN(param)) {
        return
      }
      const length = moment(moment(item.endTime || item.dueTime).startOf('day')).diff(moment(Math.max(item.startTime || item.dueTime, monday)).startOf('day'), 'days') + 1
      for (let index = 0; index < length; index++) {
        this.taskCounter[param + index] = this.taskCounter[param + index] || 0
        this.taskCounter[param + index]++
        this.maxTaskNumber = Math.max(this.taskCounter[param + index], this.maxTaskNumber)
      }
    },
    showAll () {
      if (this.isMore) {
        this.$postMessage.stateGo('app.my.task')
      } else {
        this.showTaskNumber = this.showTaskNumber === this.maxTaskNumber ? DEFAULT_SHOW_NUMBER : this.maxTaskNumber
      }
    }
  }
}
</script>
<style lang="stylus">
.calendar-allday
  &-menu
    display flex
    justify-content flex-start
    align-items stretch
    flex-wrap nowrap
    position relative
    overflow hidden
    font-size 10px
    &-left
      background-color #f1f1f1
      display flex
      flex-wrap nowrap
      flex-direction column
      justify-content space-between
      align-items flex-start
      width 36px
      padding 6px 0 6px 6px
      color #999
    &-toggle
      width 20px
      height 20px
      border-radius 50%
      background-color #f8f8f9
      display flex
      justify-content center
      align-items center
      flex-wrap nowrap
      cursor pointer
      .ibass
        color #a9a9a9
        height 12px
    &-items
      background-color #f1f1f1
      display flex
      justify-content flex-start
      align-items flex-start
      flex-wrap nowrap
      flex 1
      overflow-y: scroll
      &.transition
        transition height .3s ease-out
  &-block
    display flex
    flex-direction column
    justify-content flex-end
    align-items flex-start
    flex-wrap nowrap
    // width 90px
    flex 1
    height 100%
    border-left 1px solid #d8d8d8
    box-sizing border-box
    &:first-child
      border-left 0
    &-label
      width 68px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
    &-wrap
      display flex
      justify-content flex-start
      align-items center
      padding-left 9px
      margin-bottom 6px
      cursor pointer
      font-size 10px
      .ibass-trig-down
        color #cdc9c5
        height 12px
        font-size .75rem
  &-tasks
    position absolute
    margin-left 42px
</style>
